import type { ReactNode } from 'react';
import { toAspectRatio } from './providers';

interface EmbedFrameProps {
  children: ReactNode;
  /** Aspect ratio as "16:9" / "16/9"; defaults to 16:9. */
  ratio?: string;
}

/**
 * Responsive aspect-ratio container for iframe-based embeds. Uses the CSS
 * `aspect-ratio` property (inline, since the value is dynamic) so the frame
 * scales fluidly to the content column width.
 */
export function EmbedFrame({ children, ratio }: EmbedFrameProps) {
  return (
    <div
      className='my-lg w-full overflow-hidden'
      style={{ aspectRatio: toAspectRatio(ratio) }}
    >
      {children}
    </div>
  );
}
